import * as ltjsEnvironment from '../ltjsEnvironment';
import KeyCode from '../input/KeyCode';
import KeyManager from '../input/KeyManager';
var _keyCodePressed = new Map();
// NOTE(mikcol): was [] in legacy, perhaps it is used for perf reasons?
var KEYPRESS_MAP = [];
var MODIFIER_MAP = [];
var onKeyDown = function (event) {
    var key = getPortableKeyCode(event);
    if (key === null || key === undefined) {
        return;
    }
    if (MODIFIER_MAP[event.key] === undefined) {
        verifyModifierKeyState(event);
    }
    KeyManager.pressKey(key);
    //Prevents scrolling behavior when zooming/panning with the arrow keys
    if (KeyManager.didHandleLastAction()) {
        event.preventDefault();
    }
};
var onKeyUp = function (event) {
    if (KeyManager.didHandleLastAction()) {
        event.preventDefault();
    }
    var key = getPortableKeyCode(event);
    if (key === null || key === undefined) {
        return;
    }
    if (KeyManager.isPressed(key)) {
        KeyManager.releaseKey(key);
    }
};
ltjsEnvironment.runWhenInitialized(function () {
    if (sas.ltjs.node) {
        return;
    }
    var isMac = window.navigator.appVersion.indexOf('Mac') !== -1;
    KEYPRESS_MAP[13] = KeyCode.PVK_ENTER;
    KEYPRESS_MAP[27] = KeyCode.PVK_ESCAPE;
    KEYPRESS_MAP[33] = KeyCode.PVK_PAGEUP;
    KEYPRESS_MAP[34] = KeyCode.PVK_PAGEDOWN;
    KEYPRESS_MAP[37] = KeyCode.PVK_LEFTARROW;
    KEYPRESS_MAP[39] = KeyCode.PVK_RIGHTARROW;
    KEYPRESS_MAP[40] = KeyCode.PVK_DOWNARROW;
    KEYPRESS_MAP[38] = KeyCode.PVK_UPARROW;
    KEYPRESS_MAP[17] = KeyCode.PVK_CONTROL;
    KEYPRESS_MAP[18] = KeyCode.PVK_ALT;
    KEYPRESS_MAP[91] = isMac ? KeyCode.PVK_CONTROL : KeyCode.PVK_SUPER;
    KEYPRESS_MAP[92] = isMac ? KeyCode.PVK_CONTROL : KeyCode.PVK_SUPER;
    KEYPRESS_MAP[93] = isMac ? KeyCode.PVK_CONTROL : null;
    KEYPRESS_MAP[16] = KeyCode.PVK_SHIFT;
    KEYPRESS_MAP[36] = KeyCode.PVK_HOME;
    KEYPRESS_MAP[35] = KeyCode.PVK_END;
    KEYPRESS_MAP[32] = KeyCode.PVK_SPACE;
    KEYPRESS_MAP[65] = KeyCode.PVK_A;
    KEYPRESS_MAP[67] = KeyCode.PVK_C;
    KEYPRESS_MAP[69] = KeyCode.PVK_E;
    KEYPRESS_MAP[71] = KeyCode.PVK_G;
    KEYPRESS_MAP[82] = KeyCode.PVK_R;
    KEYPRESS_MAP[84] = KeyCode.PVK_T;
    KEYPRESS_MAP[88] = KeyCode.PVK_X; // S1230413
    KEYPRESS_MAP[89] = KeyCode.PVK_Y;
    KEYPRESS_MAP[90] = KeyCode.PVK_Z;
    KEYPRESS_MAP[121] = KeyCode.PVK_F10; //S1362307
    //In some browsers, event.key returns a space character instead of the string "Spacebar" or "Space" causing
    //the keypress map to not return a keycode in the keydown and keyup event handlers
    KEYPRESS_MAP[' '] = KeyCode.PVK_SPACE;
    // NOTE(mikcol): legacy used direct property access
    KEYPRESS_MAP.Enter = KeyCode.PVK_ENTER;
    KEYPRESS_MAP.PageUp = KeyCode.PVK_PAGEUP;
    KEYPRESS_MAP.PageDown = KeyCode.PVK_PAGEDOWN;
    KEYPRESS_MAP.Left = KeyCode.PVK_LEFTARROW;
    KEYPRESS_MAP.ArrowLeft = KeyCode.PVK_LEFTARROW;
    KEYPRESS_MAP.Right = KeyCode.PVK_RIGHTARROW;
    KEYPRESS_MAP.ArrowRight = KeyCode.PVK_RIGHTARROW;
    KEYPRESS_MAP.Down = KeyCode.PVK_DOWNARROW;
    KEYPRESS_MAP.ArrowDown = KeyCode.PVK_DOWNARROW;
    KEYPRESS_MAP.Up = KeyCode.PVK_UPARROW;
    KEYPRESS_MAP.ArrowUp = KeyCode.PVK_UPARROW;
    KEYPRESS_MAP.Control = KeyCode.PVK_CONTROL;
    KEYPRESS_MAP.Alt = KeyCode.PVK_ALT;
    KEYPRESS_MAP.OS = isMac ? KeyCode.PVK_CONTROL : KeyCode.PVK_SUPER;
    KEYPRESS_MAP.Meta = isMac ? KeyCode.PVK_CONTROL : null;
    KEYPRESS_MAP.Shift = KeyCode.PVK_SHIFT;
    KEYPRESS_MAP.Home = KeyCode.PVK_HOME;
    KEYPRESS_MAP.End = KeyCode.PVK_END;
    KEYPRESS_MAP.Spacebar = KeyCode.PVK_SPACE;
    KEYPRESS_MAP.Tab = KeyCode.PVK_TAB;
    // NOTE(mikcol): eas PVK_Escape in legacy
    KEYPRESS_MAP.Escape = KeyCode.PVK_ESCAPE;
    KEYPRESS_MAP.a = KeyCode.PVK_A;
    KEYPRESS_MAP.c = KeyCode.PVK_C;
    KEYPRESS_MAP.e = KeyCode.PVK_E;
    KEYPRESS_MAP.g = KeyCode.PVK_G;
    KEYPRESS_MAP.r = KeyCode.PVK_R;
    KEYPRESS_MAP.t = KeyCode.PVK_T;
    KEYPRESS_MAP.x = KeyCode.PVK_X; // S1230413 (Firefox)
    KEYPRESS_MAP.y = KeyCode.PVK_Y;
    KEYPRESS_MAP.z = KeyCode.PVK_Z;
    KEYPRESS_MAP.A = KeyCode.PVK_A;
    KEYPRESS_MAP.C = KeyCode.PVK_C;
    KEYPRESS_MAP.E = KeyCode.PVK_E;
    KEYPRESS_MAP.G = KeyCode.PVK_G;
    KEYPRESS_MAP.R = KeyCode.PVK_R;
    KEYPRESS_MAP.T = KeyCode.PVK_T;
    KEYPRESS_MAP.X = KeyCode.PVK_X; // S1230413 (Firefox)
    KEYPRESS_MAP.Y = KeyCode.PVK_Y;
    KEYPRESS_MAP.Z = KeyCode.PVK_Z;
    KEYPRESS_MAP.F10 = KeyCode.PVK_F10; //S1362307
    MODIFIER_MAP.altKey = KeyCode.PVK_ALT;
    MODIFIER_MAP.ctrlKey = KeyCode.PVK_CONTROL;
    MODIFIER_MAP.shiftKey = KeyCode.PVK_SHIFT;
    MODIFIER_MAP.metaKey = isMac ? KeyCode.PVK_CONTROL : KeyCode.PVK_SUPER;
    document.addEventListener('keydown', onKeyDown, { capture: true });
    document.addEventListener('keyup', onKeyUp, { capture: true });
});
export function verifyModifierKeyState(event) {
    _keyCodePressed.clear();
    //
    // Build map of keyCodes for modifier keys that are currently pressed.
    // Only marking pressed keys, not unpressed keys, allows for the mapping
    // of multiple modifier keys to the same keyCode, which we do on Mac.
    //
    for (var modifierKey in MODIFIER_MAP) {
        if (MODIFIER_MAP.hasOwnProperty(modifierKey)) {
            if (event[modifierKey]) {
                _keyCodePressed.set(MODIFIER_MAP[modifierKey], true);
            }
        }
    }
    //
    // Sync state of KeyManager for all modifier keyCodes.
    //
    for (var modifierKey in MODIFIER_MAP) {
        if (MODIFIER_MAP.hasOwnProperty(modifierKey)) {
            var keyCode = MODIFIER_MAP[modifierKey];
            if (keyCode) {
                var previousIsPressed = KeyManager.isPressed(keyCode);
                var currentIsPressed = !!_keyCodePressed.get(keyCode); // coerce to boolean
                if (previousIsPressed !== currentIsPressed) {
                    if (currentIsPressed) {
                        KeyManager.pressKey(keyCode);
                    }
                    else {
                        KeyManager.releaseKey(keyCode);
                    }
                }
            }
        }
    }
}
export function getPortableKeyCode(event) {
    var keyFirefox = event.key;
    var key = keyFirefox ? keyFirefox : event.keyCode;
    if (key) {
        return KEYPRESS_MAP[key];
    }
    return null;
}
export function removeStaticListeners() {
    document.removeEventListener('keydown', onKeyDown);
    document.removeEventListener('keyup', onKeyUp);
}
if (!sas.ltjs.node) {
    window.addEventListener('unload', removeStaticListeners);
}
